import type { CSSProperties } from "react";

type KpiRailTone = "neutral" | "positive" | "warning";

interface KpiRailItem {
  label: string;
  value: string;
  note?: string;
  tone?: KpiRailTone;
}

interface KpiRailProps {
  items: KpiRailItem[];
}

const toneMap: Record<KpiRailTone, string> = {
  neutral: "#7fd0ff",
  positive: "#77f4c3",
  warning: "#ffcf7d"
};

const shellStyle: CSSProperties = {
  display: "grid",
  gap: "16px",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 180px), 1fr))"
};

export function KpiRail({ items }: KpiRailProps) {
  return (
    <div style={shellStyle}>
      {items.map((item) => {
        const tone = toneMap[item.tone ?? "neutral"];

        return (
          <section
            key={`${item.label}-${item.value}`}
            style={{
              position: "relative",
              overflow: "hidden",
              borderRadius: "22px",
              minHeight: "146px",
              padding: "18px 18px 18px",
              background: "linear-gradient(180deg, rgba(10, 15, 28, 0.9), rgba(7, 12, 23, 0.82))",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 18px 38px rgba(3, 8, 20, 0.22)"
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: "0 auto auto 0",
                width: "100%",
                height: "3px",
                background: `linear-gradient(90deg, ${tone}, rgba(255,255,255,0))`
              }}
            />
            <div className="stack-xs">
              <span
                style={{
                  fontSize: "0.7rem",
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "rgba(214, 225, 245, 0.62)"
                }}
              >
                {item.label}
              </span>
              <div
                style={{
                  fontSize: "clamp(1.24rem, 2vw, 1.92rem)",
                  lineHeight: 1.05,
                  letterSpacing: "-0.04em",
                  color: "#f3f8ff"
                }}
              >
                {item.value}
              </div>
              {item.note ? (
                <p style={{ margin: 0, color: "rgba(221, 231, 247, 0.74)", fontSize: "0.88rem", lineHeight: 1.45 }}>
                  {item.note}
                </p>
              ) : null}
            </div>
          </section>
        );
      })}
    </div>
  );
}
